import React from 'react';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import Select from 'react-select'; // Assuming customStyles is imported or global
import RichTextEditor from '../../components/common/RichTextEditor';
import { customStyles } from '../../utils/projectSelectUtils'; // Reusing customStyles from project utils

const StepSceneScript = ({ control, projectStories, setValue }) => (
    <div className="animate-fade-in">
        <div className="form-section-title">Creative Details</div>
        <div className="form-section-title mb-4">Story Line</div>

        <Form.Group className="mb-3">
            <Form.Label className="form-label">Select Story From Same Project</Form.Label>
            <Select
                options={projectStories}
                onChange={(selected) => {
                    setValue("story_line", selected.value, { shouldDirty: true });
                }}
                placeholder="Select story..."
                styles={customStyles}
            />
        </Form.Group>
        <Controller name="story_line" control={control} render={({ field }) => <RichTextEditor {...field} />} />
        
        <Form.Group className="mb-4 mt-4">
            <Form.Label className="form-label">Character Sketch</Form.Label>
            <Controller name="character_sketch" control={control} render={({ field }) => <RichTextEditor {...field} />} />
        </Form.Group>

        <Form.Group className="mb-4">
            <Form.Label className="form-label">Audition Script </Form.Label>
            <Controller name="script_details" control={control} render={({ field }) => <RichTextEditor {...field} />} />
        </Form.Group>
        
        {/* You can add scene_details here if it's meant to be another RichTextEditor */}
        {/* <Form.Group className="mb-4">
            <Form.Label className="form-label">Scene Details</Form.Label>
            <Controller name="scene_details" control={control} render={({ field }) => <RichTextEditor {...field} />} />
        </Form.Group> */}
    </div>
);

export default StepSceneScript;